import React from 'react';
import { Link } from 'react-router-dom';

// What a visitor gets where the owner gets the ledger. Deliberately a rendered
// panel and not a redirect: a redirect to "/" from a route the visitor typed
// is how you build a loop, and it hides the fact that the page exists rather
// than explaining it. Nothing here is a login prompt -- there is nothing to
// type. The credential is which network you are on.
const HomeNetworkOnly = ({ what = 'This page' }) => (
  <div className="h-full flex items-center justify-center p-6">
    <div className="max-w-sm w-full rounded-lg border border-white/[0.06] bg-trading-dark-900/60 p-6 text-center">
      <h1 className="text-[13px] font-medium tracking-wide text-gray-200">
        Available on the home network only
      </h1>
      <p className="mt-2 text-[12px] leading-relaxed text-gray-500">
        {what} shows a live account, so it answers only to devices on the owner&rsquo;s
        private network. Everything else on the site is public.
      </p>
      <Link
        to="/"
        className="inline-block mt-4 text-[12px] text-trading-green-300 hover:text-trading-green-200 transition-colors"
      >
        Back to the dashboard
      </Link>
    </div>
  </div>
);

export default HomeNetworkOnly;
